import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-textile-stock-search',
  templateUrl: './textile-stock-search.component.html',
  styleUrls: ['./textile-stock-search.component.css']
})
export class TextileStockSearchComponent implements OnInit {
    public setting?: Setting;

    public itemsListTextileStocks: Item[] = [];

    public searchTextButtons: FormButton[] = [
        { id: 'search', type: 'primary', icon: 'fas fa-search', onClick: () => this.loadTextileStocks() }
    ];

    constructor(private datatask: DataTaskService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(1467))[0];
    }

    private async loadTextileStocks() {
        if (!this.setting) return;

        this.itemsListTextileStocks = await this.datatask.Post(1468, { searchtext: this.setting.searchtext });
    }

    public searchItems() {
        this.loadTextileStocks();
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'searchtext':
                if (this.setting?.searchtext === '') this.loadTextileStocks();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadTextileStocks();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    searchtext: string;
}
